/**
 * @fileoverview gRPC-Web generated client stub for accountpb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.14.0
// source: proto/accountpb/note.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')
const proto = {};
proto.accountpb = require('./note_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.accountpb.NoteServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.accountpb.NoteServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountpb.Note,
 *   !proto.accountpb.CreateNoteResponse>}
 */
const methodDescriptor_NoteService_CreateNote = new grpc.web.MethodDescriptor(
  '/accountpb.NoteService/CreateNote',
  grpc.web.MethodType.UNARY,
  proto.accountpb.Note,
  proto.accountpb.CreateNoteResponse,
  /**
   * @param {!proto.accountpb.Note} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.CreateNoteResponse.deserializeBinary
);


/**
 * @param {!proto.accountpb.Note} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountpb.CreateNoteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountpb.CreateNoteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountpb.NoteServiceClient.prototype.createNote =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountpb.NoteService/CreateNote',
      request,
      metadata || {},
      methodDescriptor_NoteService_CreateNote,
      callback);
};


/**
 * @param {!proto.accountpb.Note} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountpb.CreateNoteResponse>}
 *     Promise that resolves to the response
 */
proto.accountpb.NoteServicePromiseClient.prototype.createNote =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountpb.NoteService/CreateNote',
      request,
      metadata || {},
      methodDescriptor_NoteService_CreateNote);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.accountpb.ListNoteRequest,
 *   !proto.accountpb.ListNoteResponse>}
 */
const methodDescriptor_NoteService_ListNote = new grpc.web.MethodDescriptor(
  '/accountpb.NoteService/ListNote',
  grpc.web.MethodType.UNARY,
  proto.accountpb.ListNoteRequest,
  proto.accountpb.ListNoteResponse,
  /**
   * @param {!proto.accountpb.ListNoteRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.accountpb.ListNoteResponse.deserializeBinary
);


/**
 * @param {!proto.accountpb.ListNoteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.accountpb.ListNoteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.accountpb.ListNoteResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.accountpb.NoteServiceClient.prototype.listNote =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/accountpb.NoteService/ListNote',
      request,
      metadata || {},
      methodDescriptor_NoteService_ListNote,
      callback);
};


/**
 * @param {!proto.accountpb.ListNoteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.accountpb.ListNoteResponse>}
 *     Promise that resolves to the response
 */
proto.accountpb.NoteServicePromiseClient.prototype.listNote =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/accountpb.NoteService/ListNote',
      request,
      metadata || {},
      methodDescriptor_NoteService_ListNote);
};


module.exports = proto.accountpb;

